/*
 * @Author: dali
 * @Date: 2022-09-27 14:02:30
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-07-25 13:49:35
 * @FilePath: \gerlun-react-website\src\components\userForm\index.jsx
 * @Description:
 */
import React, { useState, Fragment, useImperativeHandle, useEffect } from 'react'
import { Modal, Tabs } from 'antd'
import LoginForm from '@/components/loginForm'
// import styles from './index.scss'
import RegisterForm from '../registerForm'
import ChangePwd from '../loginForm/changePwd'
import ForgetPassword from '../forgetPassword'
import WechatVerify from '../wechatVerify'
import wrapWithUser from '@/components/wrapWithUser'
import { useRef } from 'react'
import { SYSCON } from '@/const/const'

const UserForm = (props) => {
  // 属性
  const [modalVisible, handleVisible] = useState(false)
  const [tabKey, handleTabKey] = useState('login')
  const [code, handleCode] = useState('')
  const [inviterCode, handleInviterCode] = useState('')
  const registerRef = React.createRef()
  const loginRef = React.createRef()
  const forgetRef = React.createRef()
  const wechatVerifyRef = useRef(null)
  console.log('UserForm')
  // 登录成功回调
  const handleLoginSuccess = (userinfo) => {
    console.log('userinfo', userinfo)
    props.handleLoginSuccess(inviterCode)
  }
  // 关闭弹窗
  const handleModalClose = () => {
    handleVisible(false)
  }
  // 关闭弹窗
  const handleRegistClick = () => {
    handleTabKey('register')
  }
  // 关闭弹窗
  const handleForgetClick = () => {
    handleModalClose()
    forgetRef.current.open()
  }

  const onChange = (key) => {
    handleTabKey(key)
  }
  const onClose = (key) => {
    handleTabKey('login')
    handleVisible(false)
  }

  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      open
    }
  })

  const open = (code) => {
    handleVisible(true)
    handleInviterCode(code)
    if (code && code !== 'enter') {
      handleCode(code)
      handleTabKey('register')
    }
  }

  const changeToRegister = () => {
    handleVisible(true)
    handleRegistClick()
  }

  const handleWxVerify = (wechatInfo) => {
    handleModalClose()
    console.log({ wechatVerifyRef })
    wechatVerifyRef.current.open(wechatInfo)
  }
  // 修改密码
  const changePwdRef = React.createRef()
  const handleChangePwd = () => {
    changePwdRef.current.open()
  }

  useEffect(() => {
    // 密码强度为弱时
    if (localStorage.getItem(SYSCON.GelFinanceChangePws) === 'true') {
      // handleChangePwd()
    }
  })

  const isShow = tabKey === 'login'
  console.log({ isShow })
  return (
    <Fragment>
      <Modal
        destroyOnClose
        centered
        maskClosable={false}
        visible={modalVisible}
        bodyStyle={{ paddingTop: '0px' }}
        onCancel={() => onClose()}
        footer={null}
        width={420}
      >
        {
          tabKey === 'login' &&
          <LoginForm
            onRef={loginRef}
            isShow={isShow}
            handleLoginSuccess={handleLoginSuccess}
            handleModalClose={handleModalClose}
            handleRegistClick={handleRegistClick}
            handleForgetClick={handleForgetClick}
            handleWxVerify={handleWxVerify}
            handleChangePwd={handleChangePwd}
          />
        }
        {
          tabKey === 'register' &&
          <Tabs defaultActiveKey='login' activeKey={tabKey} onChange={onChange}>
            <Tabs.TabPane tab='登录' key='login'>
            </Tabs.TabPane>
            <Tabs.TabPane tab='注册' key='register'>
              <RegisterForm onRef={registerRef} handleModalClose={handleModalClose} code={code}/>
            </Tabs.TabPane>
          </Tabs>
        }

      </Modal>
      <ForgetPassword onRef={forgetRef} />
      <ChangePwd onRef={changePwdRef} handleForgetClick={handleForgetClick} setStatu={props.setStatu} />
      <WechatVerify ref={wechatVerifyRef} registerClick={changeToRegister} setStatu={props.setStatu}/>
    </Fragment>
  )
}

export default wrapWithUser(UserForm)
